import { render, staticRenderFns } from "./AppSelection.vue?vue&type=template&id=077d4f70&scoped=true"
import script from "./AppSelection.vue?vue&type=script&lang=js"
export * from "./AppSelection.vue?vue&type=script&lang=js"
import style0 from "./AppSelection.vue?vue&type=style&index=0&id=077d4f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d4f70",
  null
  
)

export default component.exports